// This file is auto-generated during build
export const version = {
  release: 'project42@38b33f4'
};
